import { render, staticRenderFns } from "./ReviewReminderTemplate.vue?vue&type=template&id=34dd5277&lang=pug&"
import script from "./ReviewReminderTemplate.vue?vue&type=script&lang=js&"
export * from "./ReviewReminderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReminderTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
